(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentPlansOrders', {
        templateUrl: 'views/components/views/consignmentPlansOrders/consignmentPlansOrders.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'consignmentPlansOrdersService', 'ieScreenBlockService', function ($stateParams, stateService, translateService, modalService, consignmentPlansOrdersService, ieScreenBlockService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            var resizing = false;
            var editing = true;
            
            let timerSearchText = null;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('searchtext') },
                    { id: 'search', icon: 'glyphicon glyphicon-search', color: 'primary', type: 'primary', onClick: () => vm.searchOrders(vm.model.setting.searchtext) }
                ],
                mconfig: {
                    enabled: true,
                    show: true,
                    activate: function (item) {
                        if (item === 'all') {
                            angular.forEach(vm.model.mconfig.records, function (data) {
                                if (angular.isDefined(data)) {
                                    if (data.canActive === true) {
                                        data.isActive = true;
                                    }
                                }
                            });
                        } else if (angular.isDefined(item) && angular.isDefined(item.item_id)) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (angular.isDefined(item)) {
                            for (var r = 0; r < vm.model.mconfig.records.length; r++) {
                                if (vm.model.mconfig.records[r].item_name === item && vm.model.mconfig.records[r].canActive === true) {
                                    vm.model.mconfig.records[r].isActive = true;
                                    break;
                                }
                            }
                        } else {
                            //vm.model.mconfig.records[4].isActive = true;
                        }
                    },
                    deactivate: function (item) {
                        if (item === 'all') {
                            angular.forEach(vm.model.mconfig.records, function (data) {
                                if (angular.isDefined(data)) {
                                    if (data.item_name === 'resize' && data.isActive) {
                                        consignmentPlansOrdersColumnResize();
                                    }
                                    if (data.canActive === true) {
                                        data.isActive = false;
                                    }
                                }
                            });
                        } else if (angular.isDefined(item) && angular.isDefined(item.item_id)) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (angular.isDefined(item)) {
                            for (var r = 0; r < vm.model.mconfig.records.length; r++) {
                                if (vm.model.mconfig.records[r].item_name === item) {
                                    vm.model.mconfig.records[r].isActive = false;
                                    break;
                                }
                            }
                        } else {
                            //vm.model.mconfig.records[4].isActive = false;
                        }
                    },
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }

                        /* RESIZING COLUMNS */
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                consignmentPlansOrdersColumnResize();
                            }
                        }
                    },
                    records: [
                        { item_id: '0', item_name: 'option', glyph: 'glyphicon-option-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, enabled: true, show: false },
                        { item_id: '2', item_name: 'plus', glyph: 'glyphicon-plus', color: 'primary', show: false },
                        { item_id: '3', item_name: 'minus', glyph: 'glyphicon-minus', color: 'primary', show: false },
                        //{ item_id: '4', item_name: 'trash', glyph: 'glyphicon-trash', color: 'primary', show: false },
                        //{ item_id: '5', item_name: 'sort', glyph: 'glyphicon-sort', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: true, show: false },
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                setting: {
                    searchtext: ''
                },
                itemsListLines: [],
                itemsListLinesRaw: [],
                loaded: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region PROCEDURE FUNCTION CALL

            vm.searchOrders = function (value) {
                vm.model.setting.searchtext = value;

                if (timerSearchText) clearTimeout(timerSearchText);

                vm.model.searchTextButtons[1].icon = 'fas fa-spinner fa-spin';

                if (!value || value.trim() === '') {
                    vm.model.itemsListLines = [];
                    vm.model.searchTextButtons[1].icon = 'glyphicon glyphicon-search';
                } else {
                    timerSearchText = setTimeout(() => {
                        consignmentPlansOrdersService.listOrders({
                            custact_no: argValue,
                            searchstring: vm.model.setting.searchtext
                        }).then(function (data) {
                            let smallDataLoad = [];

                            for (let i = 0; i < data.length; i++) {
                                data[i].item_id = illegalCharRegExp(data[i].item_id);
                                smallDataLoad.push(data[i]);
                            }

                            angular.copy(smallDataLoad, vm.model.itemsListLines);
                            angular.copy(smallDataLoad, vm.model.itemsListLinesRaw);
                            vm.model.loaded = true;

                            if (!vm.model.setting.searchtext || vm.model.setting.searchtext.trim() === '') {
                                vm.model.itemsListLines = [];
                            }

                            vm.model.searchTextButtons[1].icon = 'glyphicon glyphicon-search';
                        });
                    }, 400);
                }
            }

            // #endregion PROCEDURE FUNCTION CALL

            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.setting.searchtext = '';
                        
                        if (vm.model.setting.searchtext === '') vm.searchOrders('');
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region RESIZE COLUMN FUNCTION

            var illegalCharRegExp = function (str) {
                return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "-");
            };

            function consignmentPlansOrdersColumnResize() {
                for (var m = 0; m < vm.model.mconfig.records.length; m++) {
                    if (angular.isDefined(vm.model.mconfig.records[m]) && vm.model.mconfig.records[m].item_id === '99') {
                        vm.model.mconfig.records[m].animate = true;
                        break;
                    }
                }

                var updateList = [];

                if (angular.isDefined(vm.model.itemsListLines[0]) && angular.isDefined(vm.model.itemsListLines[0].item_secondary)) {
                    for (var r = 0; r < vm.model.itemsListLines[0].item_secondary.length; r++) {
                        if (r === 0) {
                            updateList.push({ item_id: r, item_col_width: vm.model.itemsListLines[0].item_col_width })
                        }

                        if (angular.isDefined(vm.model.itemsListLines[0].item_secondary[r])) {
                            updateList.push({ item_id: r + 1, item_col_width: vm.model.itemsListLines[0].item_secondary[r].item_col_width })
                        }
                    }
                }

                var updateParms = {
                    view_id: 'consignmentplansorders.list',
                    records: updateList
                };

                consignmentPlansOrdersService.updateColumnResize(updateParms).then(function (response) {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                }
                            }]
                        });
                    } else {
                        for (var m = 0; m < vm.model.mconfig.records.length; m++) {
                            if (angular.isDefined(vm.model.mconfig.records[m]) && vm.model.mconfig.records[m].item_id === '99') {
                                vm.model.mconfig.records[m].animate = false;
                                break;
                            }
                        }

                        setTimeout(() => {
                            vm.model.mconfig.records[m].animate = null;
                        }, 2000);
                    }

                    resizing = false;
                });
            }

            // #endregion RESIZE COLUMN FUNCTION

            // #region BUTTON SEARCH FUNCTION

            vm.searchItems = function () {
                vm.searchOrders(vm.model.setting.searchtext);
            };

            // #endregion BUTTON SEARCH FUNCTION

            // #region GRID CLICK FUNCTION

            vm.gridClick = function (item) {
                var baseItem = angular.isDefined(item.item) ? item.item : item;
                var currentItem = angular.isDefined(item.col) && item.col !== null ? baseItem.item_secondary[item.col] : baseItem;

                if (baseItem.item_id !== 0) {
                    if (argType === 'custact') {
                        ieScreenBlockService.start('message');
                        ieScreenBlockService.setMessage('Oppretter forsendelse og kobler til utkjøring');

                        consignmentPlansOrdersService.linkOrder({
                            custact_no: argValue,
                            order_internal_no: baseItem.item_id
                        }).then(function (response) {
                            if (response[0] && response[0].error_code !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].error_message,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            ieScreenBlockService.stop();
                                        }
                                    }]
                                });
                            } else {
                                ieScreenBlockService.stop();
                                stateService.go('consignmentplansconsignments', { custact_no: argValue });
                            }
                        });
                    } else {
                        ieScreenBlockService.start('message');
                        ieScreenBlockService.setMessage('Oppretter forsendelse og kobler til utkjøring');

                        consignmentPlansOrdersService.createConsignment({ order_internal_no: baseItem.item_id }).then(function (response) {
                            if (response[0] && response[0].error_code !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].error_message,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            ieScreenBlockService.stop();
                                        }
                                    }]
                                });
                            } else {
                                ieScreenBlockService.stop();

                                stateService.go('consignmentplansconsignmentcontent', {
                                    consignment_keyno: response[0].consignment_keyno,
                                    custact_no: 0
                                });
                            }
                        });
                    }
                }
            };

            // #endregion GRID CLICK FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
